// extracted by mini-css-extract-plugin
export default {"mainWrapper":"BottomStackNavigator_mainWrapper__CkVKB"};